import HeaderHtml from "./HeaderHtml.js";

export default class HeaderCmp {
    #html = new HeaderHtml();
    /** @type {HeaderMenuCmp} */
    #headerMenuCmp;

    /** @param {HeaderMenuCmp} headerMenuCmp */
    constructor(headerMenuCmp) {
        this.#headerMenuCmp = headerMenuCmp;
    }

    /** @param {HTMLElement} pageHeaderEl */
    show(pageHeaderEl) {
        this.#html.show(pageHeaderEl);
        this.#headerMenuCmp.init(this.#html.getHeaderMenuElement());
    }
}